import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class AirportService {
  private airportListSource = new BehaviorSubject<any>(null); // Initialize with null or an empty array
  AirportList$ = this.airportListSource.asObservable(); // Observable for components to subscribe to
  constructor(private http: HttpService, public data: DataService) { }

  fetchAndStoreAirports(): Promise<void> {
    return new Promise((resolve, reject) => {
      // if (localStorage.getItem('airport')) {
      // const storedAirportList = JSON.parse(localStorage.getItem('airport')!);
      // this.setAirportList(storedAirportList); // Set the airport list from localStorage
      //   resolve(); // Data already in localStorage
      // } else {
        this.http.flightgetall(`apiV2/airport`).subscribe({
          next: (data: any) => {
            const filteredData = data.data.filter((item: any) => item.is_top !== -1);
            const airport_list = filteredData.sort((a, b) => {
              if(a.country_code === 'IN' && b.country_code !== 'IN') {
                return -1 // Move a before b
              } else if (a.country_code === 'IN' && b.country_code !== 'IN') {
                return 1 // Move a before b
              } else {
                return 0
              }
            }).map(airport => ({
              ...airport,
              flag: this.data.getFlagIcon(airport.country_code),
            }));
            localStorage.setItem('airport', JSON.stringify(airport_list));
            this.setAirportList(airport_list); // Set the airport list after API call
            resolve();
          },
          error: (err) => {
            reject(err);
          }
        })
      // }
    });
  }

  setAirportList(AirportList: any) {
    this.airportListSource.next(AirportList);
  }

  Domestics_Airport = [
    { name: "Ahmedabad", airport_code: "AMD", icon: 'ahmedabad_AMD.png' },
    { name: "Belagavi", airport_code: "VDY", icon: 'belagavi_IXG.png' },
    { name: "Belagavi", airport_code: "IXG", icon: 'belagavi_VDY.png' },
    { name: "Bengaluru", airport_code: "BLR", icon: 'banglore_BLR.png' },
    { name: "Bhavnagar", airport_code: "BHU", icon: 'bhavnagar_BHU.png' },
    { name: "Bhopal", airport_code: "BHO", icon: 'bhopal_BHO.png' },
    { name: "Bhuj", airport_code: "BHJ", icon: "bhuj_BHJ.png" },
    { name: "Bidar", airport_code: "BID", icon: "bidar_BID.png" },
    { name: "Bilaspur", airport_code: "RPR", icon: "bilaspur_RPR.png" },
    { name: "Dabolim", airport_code: "GOI", icon: "dabolim_GOI.png" },
    { name: "Daporijo Airport City", airport_code: "DAE", icon: "daporijo_DAE.png" },
    { name: "Darbhanga", airport_code: "DBR", icon: "darbhanga_DBR.png" },
    { name: "Deesa", airport_code: "DEESA", icon: "deesa_DEESA.png" },
    { name: "Delhi & New Delhi City", airport_code: "DEL", icon: "delhi_DEL.png" },
    { name: "Deoghar", airport_code: "DGH", icon: "deoghar_DGH.png" },
    { name: "Dhalbhumgarh", airport_code: "IXR", icon: "dhalbhumgarh_IXR.png" },
    { name: "Dhubri", airport_code: "GAU", icon: "dhubri_GAU.png" },
    { name: "Dibrugarh City", airport_code: "DIB", icon: "dibrugarh_DIB.png" },
    { name: "Donakonda City", airport_code: "VGA", icon: "donakonda_VGA.png" },
    { name: "Forbesganj", airport_code: "IXB", icon: "forbesganj_IXB.png" },
    { name: "Gaya", airport_code: "GAY", icon: "gaya_GAY.png" },
    { name: "Guwahati", airport_code: "GAU", icon: "guwahati_GAU.png" },
    { name: "Gwalior", airport_code: "GWL", icon: "gwalior_GWL.png" },
    { name: "Hisar", airport_code: "HSS", icon: "hisar_HSS.png" },
    { name: "Hubli", airport_code: "HBX", icon: "hubli_HBX.png" },
    { name: "Indore", airport_code: "IDR", icon: "indore_IDR.png" },
    { name: "Itanagar", airport_code: "IXI", icon: "itanagar_IXI.png" },
    { name: "Jabalpur", airport_code: "JLR", icon: "jabalpur_JLR.png" },
    { name: "Jagdalpur", airport_code: "RPR", icon: "jagdalpur_RPR.png" },
    { name: "Jamnagar", airport_code: "JGA", icon: "jamnagar_JGA.png" },
    { name: "Jamshedpur", airport_code: "IXW", icon: "jamshedpur_IXW.png" },
    { name: "Jorhat", airport_code: "JRH", icon: "jorhat_JRH.png" },
    { name: "Junagadh", airport_code: "IXK", icon: "junagadh_IXK.png" },
    { name: "Kadapa", airport_code: "TIR", icon: "kadapa_TIR.png" },
    { name: "Kalaburagi", airport_code: "GBG", icon: "kalaburagi_GBG.png" },
    { name: "Kandla", airport_code: "IXY", icon: "kandla_IXY.png" },
    { name: "Kangra", airport_code: "DHM", icon: "kangra_DHM.png" },
    { name: "Kannur", airport_code: "CNN", icon: "kannur_CNN.png" },
    { name: "Khajuraho", airport_code: "HJR", icon: "khajuraho_HJR.png" },
    { name: "Khandwa", airport_code: "IDR", icon: "khandwa_IDR.png" },
    { name: "Kochi", airport_code: "COK", icon: "kochi_COK.png" },
    { name: "Kozhikode", airport_code: "CCJ", icon: "kozhikode_CCJ.png" },
    { name: "Kullu-Manali", airport_code: "KUU", icon: "kullu-manali_KUU.png" },
    { name: "Kurnool", airport_code: "HYD", icon: "kurnool_HYD.png" },
    { name: "Mangaluru", airport_code: "IXE", icon: "mangaluru_IXE.png" },
    { name: "Mopa", airport_code: "mopa", icon: "mopa_mopa.png" },
    { name: "Mundra", airport_code: "MUN", icon: "mundra_MUN.png" },
    { name: "Muzaffarpur", airport_code: "PAT", icon: "muzaffarpur_PAT.png" },
    { name: "Mysuru", airport_code: "MYQ", icon: "mysuru_MYQ.png" },
    { name: "North Lakhimpur", airport_code: "IXI", icon: "north_lakhimpur_IXI.png" },
    { name: "Panna", airport_code: "HJR", icon: "panna_HJR.png" },
    { name: "Pasighat", airport_code: "DIB", icon: "pasighat_DIB.png" },
    { name: "Patna", airport_code: "PAT", icon: "patna_PAT.png" },
    { name: "Porbandar", airport_code: "PBD", icon: "porbandar_PBD.png" },
    { name: "Raipur", airport_code: "RPRS", icon: "raipur_RPRS.png" },
    { name: "Rajahmundry", airport_code: "RJA", icon: "rajahmundry_RJA.png" },
    { name: "Rajkot", airport_code: "RAJ", icon: "rajkot_RAJ.png" },
    { name: "Ranchi", airport_code: "IXR", icon: "ranchi_IXR.png" },
    { name: "Satna", airport_code: "satna", icon: "satna_satna.png" },
    { name: "Shimla", airport_code: "SLV", icon: "shimla_SLV.png" },
    { name: "Shivamogga", airport_code: "shivamogga", icon: "shivamogga_shivamogga.png" },
    { name: "Silchar", airport_code: "IXS", icon: "silchar_IXS.png" },
    { name: "Surat", airport_code: "STV", icon: "surat_STV.png" },
    { name: "Tezpur", airport_code: "TEZ", icon: "tezpur_TEZ.png" },
    { name: "Tezu", airport_code: "tezu", icon: "tezu_tezu.png" },
    { name: "Thiruvananthapuram", airport_code: "TRV", icon: "thiruvananthapuram_TRV.png" },
    { name: "Tirupati", airport_code: "tirupati", icon: "tirupati_tirupati.png" },
    { name: "Vadodara", airport_code: "BDQ", icon: "vadodara_BDQ.png" },
    { name: "Visakhapatnam", airport_code: "VTZ", icon: "visakhapatnam_VTZ.png" },
    { name: "Ziro City", airport_code: "ziro", icon: "ziro_city_ziro.png" },
    { name: "Aizawl", airport_code: "AJL", icon: "aizawl_AJL.png" },
    { name: "Akola", airport_code: "AKD", icon: "akola_AKD.png" },
    { name: "Ajmer", airport_code: "KQH", icon: "ajmer_KQH.png" },
    { name: "Amritsar", airport_code: "ATQ", icon: "amritsar_ATQ.png" },
    { name: "Aurangabad", airport_code: "IXU", icon: "aurangabad_IXU.png" },
    { name: "Bathinda", airport_code: "BUP", icon: "bathinda_BUP.png" },
    { name: "Bhubaneswar", airport_code: "BBI", icon: "bhubaneswar_BBI.png" },
    { name: "Bikaner", airport_code: "BKB", icon: "bikaner_BKB.png" },
    { name: "Chennai", airport_code: "MAA", icon: "chennai_MAA.png" },
    { name: "Coimbatore", airport_code: "CJB", icon: "coimbatore_CJB.png" },
    { name: "Dimapur", airport_code: "DMU", icon: "dimapur_DMU.png" },
    { name: "Gangtok", airport_code: "gangtok", icon: "gangtok.png" },
    { name: "Gondia", airport_code: "GND", icon: "gondia_GND.png" },
    { name: "Imphal", airport_code: "IMF", icon: "imphal_IMF.png" },
    { name: "Jaipur", airport_code: "JAI", icon: "jaipur_JAI.png" },
    { name: "Jaisalmer", airport_code: "JSA", icon: "jaisalmer_JSA.png" },
    { name: "Jalandhar", airport_code: "jalandhar", icon: "jalandhar.png" },
    { name: "Jalgaon", airport_code: "JLG", icon: "jalgaon_JLG.png" },
    { name: "Jeypore", airport_code: "jeypore", icon: "jeypore.png" },
    { name: "Jharsuguda", airport_code: "JRG", icon: "jharsuguda_JRG.png" },
    { name: "Jodhpur", airport_code: "JDH", icon: "jodhpur_JDH.png" },
    { name: "Kolhapur", airport_code: "KLH", icon: "kolhapur_KLH.png" },
    { name: "Kota", airport_code: "kota", icon: "kota_kota.png" },
    { name: "Ludhiana", airport_code: "ludhiana", icon: "ludhiana_ludhiana.png" },
    { name: "Madurai", airport_code: "IXM", icon: "madurai_IXM.png" },
    { name: "Mumbai", airport_code: "BOM", icon: "mumbai_BOM.png" },
    { name: "Nagpur", airport_code: "nagpur", icon: "nagpur_nagpur.png" },
    { name: "Nanded", airport_code: "NDC", icon: "nanded_NDC.png" },
    { name: "Nashik", airport_code: "ISK", icon: "nashik_ISK.png" },
    { name: "Pathankot", airport_code: "IXP", icon: "pathankot_IXP.png" },
    { name: "Pune", airport_code: "PNQ", icon: "pune_PNQ.png" },
    { name: "Rourkela", airport_code: "rourkela", icon: "rourkela_rourkela.png" },
    { name: "Salem", airport_code: "SXV", icon: "salem_SXV.png" },
    { name: "Shella", airport_code: "SHL", icon: "shella_SHL.png" },
    { name: "Shillong", airport_code: "shillong", icon: "shillong_shillong.png" },
    { name: "Shirdi", airport_code: "SAG", icon: "shirdi_SAG.png" },
    { name: "Sindhudurg", airport_code: "SDR", icon: "sindhudurg_SDR.png" },
    { name: "Solapur", airport_code: "SSE", icon: "solapur_SSE.png" },
    { name: "Thanjavur", airport_code: "TJV", icon: "thanjavur_TJV.png" },
    { name: "Thoothukkudi", airport_code: "TCR", icon: "thoothukkudi_TCR.png" },
    { name: "Tiruchirappalli", airport_code: "tiruchirappalli", icon: "tiruchirappalli_tiruchirappalli.png" },
    { name: "Udaipur", airport_code: "UDR", icon: "udaipur_UDR.png" },
    { name: "Vellore", airport_code: "vellore", icon: "vellore_vellore.png" },
    { name: "Agartala", airport_code: "IXA", icon: "agartala_IXA.png" },
    { name: "Agatti Island", airport_code: "AGX", icon: "agatti_island_AGX.png" },
    { name: "Agra", airport_code: "AGR", icon: "agra_AGR.png" },
    { name: "Asansol", airport_code: "RDP", icon: "asansol_RDP.png" },
    { name: "Balurghat", airport_code: "balurghat", icon: "balurghat_balurghat.png" },
    { name: "Bareilly", airport_code: "BEK", icon: "bareilly_BEK.png" },
    { name: "Chandigarh", airport_code: "IXC", icon: "chandigarh_IXC.png" },
    { name: "Cooch Behar", airport_code: "COH", icon: "cooch_behar_COH.png" },
    { name: "Dehradun", airport_code: "DED", icon: "dehradun_DED.png" },
    { name: "Diu", airport_code: "DIU", icon: "diu_DIU.png" },
    { name: "Durgapur", airport_code: "durgapur", icon: "durgapur_durgapur.png" },
    { name: "Faizabad", airport_code: "LKO", icon: "faizabad_LKO.png" },
    { name: "Ghaziabad", airport_code: "HDO", icon: "ghaziabad_HDO.png" },
    { name: "Gorakhpur", airport_code: "GOP", icon: "gorakhpur_GOP.png" },
    { name: "Hyderabad", airport_code: "hyderabad", icon: "hyderabad_hyderabad.png" },
    { name: "Jammu", airport_code: "IXJ", icon: "jammu_IXJ.png" },
    { name: "Kailashahar", airport_code: "IXH", icon: "kailashahar_IXH.png" },
    { name: "Kamalpur", airport_code: "IXQ", icon: "kamalpur_IXQ.png" },
    { name: "Kanpur", airport_code: "KNU", icon: "kanpur_KNU.png" },
    { name: "Khowai", airport_code: "IXN", icon: "khowai_IXN.png" },
    { name: "Kolkata", airport_code: "CCU", icon: "kolkata_CCU.png" },
    { name: "Kushinagar", airport_code: "KUA", icon: "kushinagar_KUA.png" },
    { name: "Lalitpur", airport_code: "LTU", icon: "lalitpur_LTU.png" },
    { name: "Leh", airport_code: "IXL", icon: "leh_IXL.png" },
    { name: "Lucknow", airport_code: "lucknow", icon: "lucknow_lucknow.png" },
    { name: "Malda", airport_code: "malda", icon: "malda_malda.png" },
    { name: "Meerut", airport_code: "meerut", icon: "meerut_meerut.png" },
    { name: "Moradabad", airport_code: "moradabad", icon: "moradabad_moradabad.png" },
    { name: "National Capital Region (NCR)", airport_code: "ncr", icon: "ncr_ncr.png" },
    { name: "Pantnagar", airport_code: "PGH", icon: "pantnagar_PGH.png" },
    { name: "Pithoragarh", airport_code: "pithoragarh", icon: "pithoragarh_pithoragarh.png" },
    { name: "Pondicherry", airport_code: "PNY", icon: "pondicherry_PNY.png" },
    { name: "Port Blair", airport_code: "IXZ", icon: "port_blair_IXZ.png" },
    { name: "Prayagraj", airport_code: "IXD", icon: "prayagraj_IXD.png" },
    { name: "Siliguri", airport_code: "siliguri", icon: "siliguri_siliguri.png" },
    { name: "Varanasi", airport_code: "VNS", icon: "varanasi_VNS.png" },
    { name: "Warangal", airport_code: "warangal", icon: "warangal_warangal.png" },
    { name: "Berhampur", airport_code: "berhampur", icon: "berhampur_berhampur.png" },
    { name: "Bhilai", airport_code: "bhilai", icon: "bhilai_bhilai.png" },
    { name: "Darjeeling", airport_code: "darjeeling", icon: "darjeeling_darjeeling.png" },
    { name: "Dhanbad", airport_code: "dhanbad", icon: "dhanbad_dhanbad.png" },
    { name: "Gangtok", airport_code: "PYG", icon: "gangtok_PYG.png" },
    { name: "Kharagpur", airport_code: "kharagpur", icon: "kharagpur_kharagpur.png" },
    { name: "Puri", airport_code: "puri", icon: "puri_puri.png" },
    { name: "Panaji", airport_code: "panaji", icon: "panaji_panaji.png" },
    { name: "Pushkar", airport_code: "pushkar", icon: "pushkar_pushkar.png" },
    { name: "Aligarh", airport_code: "aligarh", icon: "aligarh_aligarh.png" },
    { name: "Allahabad", airport_code: "allahabad", icon: "allahabad_allahabad.png" },
    { name: "Bareilly", airport_code: "bareilly", icon: "bareilly_bareilly.png" },
    { name: "Goa", airport_code: "goa", icon: "goa_goa.png" },
    { name: "Jhansi", airport_code: "jhansi", icon: "jhansi_jhansi.png" },
    { name: "Bangalore", airport_code: "bangalore", icon: "bangalore_bangalore.png" },
    { name: "Hampi", airport_code: "hampi", icon: "hampi_hampi.png" },
    { name: "Kanchipuram", airport_code: "kanchipuram", icon: "kanchipuram_kanchipuram.png" },
    { name: "Kanyakumari", airport_code: "kanyakumari", icon: "kanyakumari_kanyakumari.png" },
    { name: "Mahabalipuram", airport_code: "mahabalipuram", icon: "mahabalipuram_mahabalipuram.png" },
    { name: "Mysore", airport_code: "mysore", icon: "mysore_mysore.png" },
    { name: "Ooty", airport_code: "ooty", icon: "ooty_ooty.png" },
    { name: "Trichy", airport_code: "trichy", icon: "trichy_trichy.png" },
    { name: "Alappuzha", airport_code: "alappuzha", icon: "alappuzha_alappuzha.png" },
    { name: "Ariyalur", airport_code: "ariyalur", icon: "ariyalur_ariyalur.png" },
    { name: "Bagalkot", airport_code: "bagalkot", icon: "bagalkot_bagalkot.png" },
    { name: "Ballari", airport_code: "ballari", icon: "ballari_ballari.png" },
    { name: "Chamarajanagar", airport_code: "chamarajanagar", icon: "chamarajanagar_chamarajanagar.png" },
    { name: "Chengalpattu", airport_code: "chengalpattu", icon: "chengalpattu_chengalpattu.png" },
    { name: "Chikkaballapura", airport_code: "chikkaballapura", icon: "chikkaballapura_chikkaballapura.png" },
    { name: "Chikkamagaluru", airport_code: "chikkamagaluru", icon: "chikkamagaluru_chikkamagaluru.png" },
    { name: "Chitradurga", airport_code: "chitradurga", icon: "chitradurga_chitradurga.png" },
    { name: "Cuddalore", airport_code: "cuddalore", icon: "cuddalore_cuddalore.png" },
    { name: "Dakshina Kannada", airport_code: "dakshina", icon: "dakshina_dakshina.png" },
    { name: "Davanagere", airport_code: "davanagere", icon: "davanagere_davanagere.png" },
    { name: "Dharmapuri", airport_code: "dharmapuri", icon: "dharmapuri_dharmapuri.png" },
    { name: "Dharwad", airport_code: "dharwad", icon: "dharwad_dharwad.png" },
    { name: "Dindigul", airport_code: "dindigul", icon: "dindigul_dindigul.png" },
    { name: "Ernakulam", airport_code: "ernakulam", icon: "ernakulam_ernakulam.png" },
    { name: "Erode", airport_code: "erode", icon: "erode_erode.png" },
    { name: "Gadag", airport_code: "gadag", icon: "gadag_gadag.png" },
    { name: "Hassan", airport_code: "hassan", icon: "hassan_hassan.png" },
    { name: "Haveri", airport_code: "haveri", icon: "haveri_haveri.png" },
    { name: "Idukki", airport_code: "idukki", icon: "idukki_idukki.png" },
    { name: "Kallakurichi", airport_code: "kallakurichi", icon: "kallakurichi_kallakurichi.png" },
    { name: "Kanyakumari", airport_code: "trvs", icon: "kanyakumari_trvs.png" },
    { name: "Kancheepuram", airport_code: "kancheepuram", icon: "kancheepuram_kancheepuram.png" },
    { name: "Karur", airport_code: "karur", icon: "karur_karur.png" },
    { name: "Kasaragod", airport_code: "kasaragod", icon: "kasaragod_kasaragod.png" },
    { name: "Kodagu", airport_code: "kodagu", icon: "kodagu_kodagu.png" },
    { name: "Kolar", airport_code: "kolar", icon: "kolar_kolar.png" },
    { name: "Kollam", airport_code: "kollam", icon: "kollam_kollam.png" },
    { name: "Koppal", airport_code: "koppal", icon: "koppal_koppal.png" },
    { name: "Kottayam", airport_code: "kottayam", icon: "kottayam_kottayam.png" },
    { name: "Krishnagiri", airport_code: "krishnagiri", icon: "krishnagiri_krishnagiri.png" },
    { name: "Malappuram", airport_code: "malappuram", icon: "malappuram_malappuram.png" },
    { name: "Mandya", airport_code: "mandya", icon: "mandya_mandya.png" },
    { name: "Manjeri", airport_code: "manjeri", icon: "manjeri_manjeri.png" },
    { name: "Mayiladuthurai", airport_code: "mayiladuthurai", icon: "mayiladuthurai_mayiladuthurai.png" },
    { name: "Nagapattinam", airport_code: "nagapattinam", icon: "nagapattinam_nagapattinam.png" },
    { name: "Namakkal", airport_code: "namakkal", icon: "namakkal_namakkal.png" },
    { name: "Nilgiris", airport_code: "nilgiris", icon: "nilgiris_nilgiris.png" },
    { name: "Palakkad", airport_code: "palakkad", icon: "palakkad_palakkad.png" },
    { name: "Pathanamthitta", airport_code: "pathanamthitta", icon: "pathanamthitta_pathanamthitta.png" },
    { name: "Perambalur", airport_code: "perambalur", icon: "perambalur_perambalur.png" },
    { name: "Pudukkottai", airport_code: "pudukkottai", icon: "pudukkottai_pudukkottai.png" },
    { name: "Raichur", airport_code: "raichur", icon: "raichur_raichur.png" },
    { name: "Ramanagara", airport_code: "ramanagara", icon: "ramanagara_ramanagara.png" },
    { name: "Ramanathapuram", airport_code: "ramanathapuram", icon: "ramanathapuram_ramanathapuram.png" },
    { name: "Ranipet", airport_code: "ranipet", icon: "ranipet_ranipet.png" },
    { name: "Sivaganga", airport_code: "sivaganga", icon: "sivaganga_sivaganga.png" },
    { name: "Tenkasi", airport_code: "tenkasi", icon: "tenkasi_tenkasi.png" },
    { name: "Theni", airport_code: "theni", icon: "theni_theni.png" },
    { name: "Thoothukudi", airport_code: "thoothukudi", icon: "thoothukudi_thoothukudi.png" },
    { name: "Thrissur", airport_code: "thrissur", icon: "thrissur_thrissur.png" },
    { name: "Tirunelveli", airport_code: "tirunelveli", icon: "tirunelveli_tirunelveli.png" },
    { name: "Tirupathur", airport_code: "trupathur", icon: "tirupathur_trupathur.png" },
    { name: "Tiruppur", airport_code: "tiruppur", icon: "tiruppur_tiruppur.png" },
    { name: "Tiruvallur", airport_code: "tiruvallur", icon: "tiruvallur_tiruvallur.png" },
    { name: "Tiruvannamalai", airport_code: "tiruvannamalai", icon: "tiruvannamalai_tiruvannamalai.png" },
    { name: "Tiruvarur", airport_code: "tiruvarur", icon: "tiruvarur_tiruvarur.png" },
    { name: "Tumakuru", airport_code: "tumakuru", icon: "tumakuru_tumakuru.png" },
    { name: "Udupi", airport_code: "udupi", icon: "udupi_udupi.png" },
    { name: "Uttara Kannada", airport_code: "kannada", icon: "uttara_kannada.png" },
    { name: "Vijayanagara", airport_code: "vijayanagara", icon: "vijayanagara_vijayanagara.png" },
    { name: "Vijayapura", airport_code: "vijayapura", icon: "vijayapura_vijayapura.png" },
    { name: "Viluppuram", airport_code: "viluppuram", icon: "viluppuram_viluppuram.png" },
    { name: "Virudhunagar", airport_code: "virudhunagar", icon: "virudhunagar_virudhunagar.png" },
    { name: "Wayanad", airport_code: "wayanad", icon: "wayanad_wayanad.png" },
    { name: "Yadgir", airport_code: "yadgir", icon: "yadgir_yadgir.png" },
    { name: "Amalapuram", airport_code: "amalapuram", icon: "amalapuram_amalapuram.png" },
    { name: "Anakapalli", airport_code: "anakapalli", icon: "anakapalli_anakapalli.png" },
    { name: "Anantapuram", airport_code: "anantapuram", icon: "anantapuram_anantapuram.png" },
    { name: "Bapatla", airport_code: "bapatla", icon: "bapatla_bapatla.png" },
    { name: "Bhimavaram", airport_code: "bhimavaram", icon: "bhimavaram_bhimavaram.png" },
    { name: "Chittoor", airport_code: "chittoor", icon: "chittoor_chittoor.png" },
    { name: "Eluru", airport_code: "eluru", icon: "eluru_eluru.png" },
    { name: "Guntur", airport_code: "guntur", icon: "guntur_guntur.png" },
    { name: "Kakinada", airport_code: "kakinada", icon: "kakinada_kakinada.png" },
    { name: "Machilipatnam", airport_code: "machilipatnam", icon: "machilipatnam_machilipatnam.png" },
    { name: "Nandyal", airport_code: "nandyal", icon: "nandyal_nandyal.png" },
    { name: "Narasaraopeta", airport_code: "narasaraopeta", icon: "narasaraopeta_narasaraopeta.png" },
    { name: "Nellore", airport_code: "nellore", icon: "nellore_nellore.png" },
    { name: "Ongole", airport_code: "ongole", icon: "ongole_ongole.png" },
    { name: "Paderu", airport_code: "paderu", icon: "paderu_paderu.png" },
    { name: "Parvathipuram Manyam", airport_code: "manyam", icon: "manyam_parvathipuram.png" },
    { name: "Puttaparthi", airport_code: "puttaparthi", icon: "puttaparthi_puttaparthi.png" },
    { name: "Rajamahendravaram", airport_code: "rajamahendravaram", icon: "rajamahendravaram_rajamahendravaram.png" },
    { name: "Rayachoti", airport_code: "rayachoti", icon: "rayachoti_rayachoti.png" },
    { name: "Srikakulam", airport_code: "srikakulam", icon: "srikakulam_srikakulam.png" },
    { name: "Vijayawada", airport_code: "vijayawada", icon: "vijayawada_vijayawada.png" },
    { name: "Vizianagaram", airport_code: "vizianagaram", icon: "vizianagaram_vizianagaram.png" }
  
  ]

  Internation_Airport = [
    { name: "Abel Santamaría Airport", airport_code: "SNU" },
    { name: "A.N.R. Robinson International Airport", airport_code: "TAB" },
    { name: "Acapulco International Airport", airport_code: "ACA" },
    { name: "Aeroparque Jorge Newbery", airport_code: "AEP" },
    { name: "Agadir–Al Massira Airport", airport_code: "AGA" },
    { name: "Aguascalientes International Airport", airport_code: "AGU" },
    { name: "Akron Executive Airport", airport_code: "AKC" },
    { name: "Albany International Airport", airport_code: "ALB" },
    { name: "Albuquerque International Sunport", airport_code: "ABQ" },
    { name: "Angads Airport", airport_code: "OUD" },
    { name: "Appleton International Airport", airport_code: "ATW" },
    { name: "Argyle International Airport", airport_code: "SVD" },
    { name: "Assiut Airport", airport_code: "ATZ" },
    { name: "Aswan International Airport", airport_code: "ASW" },
    { name: "Atlantic City International Airport", airport_code: "ACY" },
    { name: "Augusto C. Sandino International Airport", airport_code: "MGA" },
    { name: "Austin–Bergstrom International Airport", airport_code: "AUS" },
    { name: "Bahías de Huatulco International Airport", airport_code: "HUX" },
    { name: "Bajío International Airport", airport_code: "BJX", },
    { name: "Bangor International Airport", airport_code: "BGR", },
    { name: "Baltimore/Washington International Airport", airport_code: "BWI", },
    { name: "Birmingham–Shuttlesworth International Airport", airport_code: "BHM", },
    { name: "Bocas del Toro 'Isla Colón' International Airport", airport_code: "BOC", },
    { name: "Cincinnati/Northern Kentucky International Airport", airport_code: "CVG" },
    { name: "Bellingham International Airport", airport_code: "BLI", },
    { name: "Bluefields Airport", airport_code: "BEF", },
    { name: "Boise Airport", airport_code: "BOI", },
    { name: "Borg El Arab Airport", airport_code: "HBE", },
    { name: "Bradley International Airport", airport_code: "BDL", },
    { name: "Buffalo Niagara International Airport", airport_code: "BUF", },
    { name: "Cairo International Airport", airport_code: "CAI" },
    { name: "Calgary International Airport", airport_code: "YYC" },
    { name: "Cancún International Airport", airport_code: "CUN" },
    { name: "Canouan Airport", airport_code: "CIW" },
    { name: "Cap-Haïtien International Airport", airport_code: "CAP" },
    { name: "Capital Region International Airport", airport_code: "LAN" },
    { name: "Cataratas del Iguazú International Airport", airport_code: "IGR" },
    { name: "Charles Kirkconnell International Airport", airport_code: "CYB" },
    { name: "Charleston International Airport", airport_code: "CHS" },
    { name: "Charlotte Douglas International Airport", airport_code: "CLT" },
    { name: "Chihuahua International Airport", airport_code: "CUU" },
    { name: "Chub Cay International Airport", airport_code: "CCZ" },
    { name: "Cibao International Airport", airport_code: "STI" },
    { name: "Ciudad del Carmen International Airport", airport_code: "CME" },
    { name: "Clayton J. Lloyd International Airport", airport_code: "AXA" },
    { name: "Cleveland Hopkins International Airport", airport_code: "CLE" },
    { name: "Clinton National Airport", airport_code: "LIT" },
    { name: "Corn Island Airport", airport_code: "RNI" },
    { name: "Cozumel International Airport", airport_code: "CZM" },
    { name: "Culiacán International Airport", airport_code: "CUL" },
    { name: "Curaçao International Airport", airport_code: "CUR" },
    { name: "Cyril E. King Airport", airport_code: "STT" },
    { name: "Dakhla Airport", airport_code: "VIL" },
    { name: "Dallas/Fort Worth International Airport", airport_code: "DFW" },
    { name: "Daniel K. Inouye International Airport", airport_code: "HNL" },
    { name: "Daniel Oduber Quirós International Airport", airport_code: "LIR" },
    { name: "Dayton International Airport", airport_code: "DAY" },
    { name: "Denver International Airport", airport_code: "DEN" },
    { name: "Des Moines International Airport", airport_code: "DSM" },
    { name: "Detroit Metropolitan Airport", airport_code: "DTW" },
    { name: "Djerba–Zarzis International Airport", airport_code: "DJE" },
    { name: "Douglas–Charles Airport", airport_code: "DOM" },
    { name: "Dulles International Airport", airport_code: "IAD" },
    { name: "Durango International Airport", airport_code: "DGO" },
    { name: "Edmonton International Airport", airport_code: "YEG" },
    { name: "El Alamein International Airport", airport_code: "DBB" },
    { name: "El Alto International Airport", airport_code: "LPB" },
    { name: "El Arish International Airport", airport_code: "AAC" },
    { name: "El Paso International Airport", airport_code: "ELP" },
    { name: "El Salvador International Airport", airport_code: "SAL" },
    { name: "Enfidha–Hammamet International Airport", airport_code: "NBE" },
    { name: "Enrique Malek International Airport", airport_code: "DAV" },
    { name: "Exuma International Airport", airport_code: "GGT" },
    { name: "F. D. Roosevelt Airport", airport_code: "SXM" },
    { name: "Fairbanks International Airport", airport_code: "FAI" },
    { name: "Felipe Ángeles International Airport", airport_code: "NLU" },
    { name: "Fès–Saïs Airport", airport_code: "FEZ" },
    { name: "Flamingo International Airport", airport_code: "BON" },
    { name: "Francistown International Airport", airport_code: "FRW" },
    { name: "Frank País Airport", airport_code: "HOG" },
    { name: "Fredericton International Airport", airport_code: "YFC" },
    { name: "Fresno Yosemite International Airport", airport_code: "FAT" },
    { name: "Gander International Airport", airport_code: "YQX" },
    { name: "General Lucio Blanco International Airport", airport_code: "REX" },
    { name: "General Mitchell International Airport", airport_code: "MKE" },
    { name: "George Bush Intercontinental Airport", airport_code: "IAH" },
    { name: "Governor Francisco Gabrielli International Airport", airport_code: "MDZ" },
    { name: "Fort Lauderdale–Hollywood International Airport", airport_code: "FLL" },
    { name: "General Francisco Mujica International Airport", airport_code: "MLM" },
    { name: "Golosón International Airport", airport_code: "LCE" },
    { name: "Grand Bahama International Airport", airport_code: "FPO" },
    { name: "Gerald R. Ford International Airport", airport_code: "GRR" },
    { name: "Greater Moncton Roméo LeBlanc International Airport", airport_code: "YQM" },
    { name: "Green Bay–Austin Straubel International Airport", airport_code: "GRB" },
    { name: "Hartsfield–Jackson Atlanta International Airport", airport_code: "ATL" },
    { name: "Grantley Adams International Airport", airport_code: "BGI" },
    { name: "Gregorio Luperón International Airport", airport_code: "POP" },
    { name: "Gustaf III Airport", airport_code: "SBH" },
    { name: "Halifax Stanfield International Airport", airport_code: "YHZ" },
    { name: "Harrisburg International Airport", airport_code: "MDT" },
    { name: "Harry Reid International Airport", airport_code: "LAS" },
    { name: "Hassan I Airport", airport_code: "EUN" },
    { name: "Henry E. Rohlsen Airport", airport_code: "STX" },
    { name: "Hermosillo International Airport", airport_code: "HMO" },
    { name: "Hewanorra International Airport", airport_code: "UVF" },
    { name: "Hilo International Airport", airport_code: "ITO" },
    { name: "Huntsville International Airport", airport_code: "HSV" },
    { name: "Hurghada International Airport", airport_code: "HRG" },
    { name: "Ignacio Agramonte International Airport", airport_code: "CMW" },
    { name: "Ilulissat Airport", airport_code: "JAV" },
    { name: "Jackson–Medgar Wiley Evers International Airport", airport_code: "JAN" },
    { name: "Ingeniero Aeronáutico Ambrosio L.V. Taravella", airport_code: "COR" },
    { name: "Ixtapa-Zihuatanejo International Airport", airport_code: "ZIH" },
    { name: "Indianapolis International Airport", airport_code: "IND" },
    { name: "Jaime González Airport", airport_code: "CFG" },
    { name: "Jacksonville International Airport", airport_code: "JAX" },
    { name: "Jardines del Rey Airport", airport_code: "CCC" },
    { name: "John A. Osborne Airport", airport_code: "MNI" },
    { name: "John F. Kennedy International Airport", airport_code: "JFK" },
    { name: "Jorge Wilstermann International Airport", airport_code: "CBB" },
    { name: "José Martí International Airport", airport_code: "HAV" },
    { name: "Juancho E. Yrausquin Airport", airport_code: "SAB" },
    { name: "Juan Gualberto Gómez Airport", airport_code: "VRA" },
    { name: "Juan Manuel Gálvez International Airport", airport_code: "RTB" },
    { name: "Juan Santamaría International Airport", airport_code: "SJO" },
    { name: "Juneau International Airport", airport_code: "JNU" },
    { name: "Kangerlussuaq Airport", airport_code: "SFJ" },
    { name: "Kansas City International Airport", airport_code: "MCI" },
    { name: "Kasane Airport", airport_code: "BBK" },
    { name: "Kenmore Air Harbor Seaplane Base", airport_code: "LKE" },
    { name: "Ketchikan International Airport", airport_code: "KTN" },
    { name: "Key West International Airport", airport_code: "EYW" },
    { name: "King County International Airport", airport_code: "BFI" },
    { name: "Kona International Airport", airport_code: "KOA" },
    { name: "L.F. Wade International Airport", airport_code: "BDA" },
    { name: "La Aurora International Airport", airport_code: "GUA" },
    { name: "LaGuardia Airport", airport_code: "LGA" },
    { name: "Lakeland Linder International Airport", airport_code: "LAL" },
    { name: "Las Américas International Airport", airport_code: "SDQ" },
    { name: "John Glenn Columbus International Airport", airport_code: "CMH" },
    { name: "Licenciado Gustavo Díaz Ordaz International Airport", airport_code: "PVR" },
    { name: "La Romana International Airport", airport_code: "LRM" },
    { name: "Logan International Airport", airport_code: "BOS" },
    { name: "Loreto International Airport", airport_code: "LTO" },
    { name: "Los Angeles International Airport", airport_code: "LAX" },
    { name: "Los Cabos International Airport", airport_code: "SJD" },
    { name: "Luis Muñoz Marín International Airport", airport_code: "SJU" },
    { name: "Luxor International Airport", airport_code: "LXR" },
    { name: "Lynden Pindling International Airport", airport_code: "NAS" },
    { name: "María Montez International Airport", airport_code: "BRX" },
    { name: "Marrakesh Menara Airport", airport_code: "RAK" },
    { name: "Marsa Alam International Airport", airport_code: "RMF" },
    { name: "Marsh Harbour International Airport", airport_code: "MHH" },
    { name: "Louis Armstrong New Orleans International Airport", airport_code: "MSY" },
    { name: "Louisville Muhammad Ali International Airport", airport_code: "SDF" },
    { name: "Martinique Aimé Césaire International Airport", airport_code: "FDF" },
    { name: "Maun Airport", airport_code: "MUB" },
    { name: "Maurice Bishop International Airport", airport_code: "GND" },
    { name: "Mazatlán International Airport", airport_code: "MZT" },
    { name: "McGhee Tyson Airport", airport_code: "TYS" },
    { name: "Melbourne Orlando International Airport", airport_code: "MLB" },
    { name: "Mérida International Airport", airport_code: "MLD" },
    { name: "Mersa Matruh International Airport", airport_code: "MUH" },
    { name: "Mexico City International Airport", airport_code: "MEX" },
    { name: "Miami International Airport", airport_code: "MIA" },
    { name: "Midland International Air and Space Port", airport_code: "MAF" },
    { name: "Monastir Habib Bourguiba International Airport", airport_code: "MIR" },
    { name: "Miguel Hidalgo y Costilla Guadalajara", airport_code: "GDL" },
    { name: "Minneapolis–Saint Paul International Airport", airport_code: "MSP" },
    { name: "Ministro Pistarini International Airport", airport_code: "EZE" },
    { name: "Midway International Airport", airport_code: "MDW" },
    { name: "Mohammed V International Airport", airport_code: "CMN" },
    { name: "Monterrey International Airport", airport_code: "MTY" },
    { name: "Montréal–Trudeau International Airport", airport_code: "YUL" },
    { name: "Mundo Maya International Airport", airport_code: "FRS" },
    { name: "Myrtle Beach International Airport", airport_code: "MYR" },
    { name: "Nador International Airport", airport_code: "NDR" },
    { name: "Narsarsuaq Airport", airport_code: "UAK" },
    { name: "Nashville International Airport", airport_code: "BNA" },
    { name: "Norman Manley International Airport", airport_code: "KIN" },
    { name: "Nuuk Airport", airport_code: "GOH" },
    { name: "Oaxaca International Airport", airport_code: "OAX" },
    { name: "O'Hare International Airport", airport_code: "ORD" },
    { name: "Owen Roberts International Airport", airport_code: "GCM" },
    { name: "Ottawa Macdonald–Cartier International Airport", airport_code: "YOW" },
    { name: "Piloto Civil Norberto Fernández", airport_code: "ROS" },
    { name: "Québec City Jean Lesage International Airport", airport_code: "YQB" },
    { name: "Paine Field", airport_code: "PAE" },
    { name: "Palm Beach International Airport", airport_code: "PBI" },
    { name: "Panama Pacifico International Airport", airport_code: "BLB" },
    { name: "Philip S. W. Goldson International Airport", airport_code: "BZE" },
    { name: "Piarco International Airport", airport_code: "POS" },
    { name: "Piedmont Triad International Airport", airport_code: "GSO" },
    { name: "Playa de Oro International Airport", airport_code: "ZLO" },
    { name: "Pointe-à-Pitre International Airport", airport_code: "PTP" },
    { name: "Princess Juliana International Airport", airport_code: "SXM" },
    { name: "Providenciales Airport", airport_code: "PLS" },
    { name: "Puebla International Airport", airport_code: "PBC" },
    { name: "Puerto Escondido International Airport", airport_code: "PXM" },
    { name: "Punta Cana International Airport", airport_code: "PUJ" },
    { name: "Queen Beatrix International Airport", airport_code: "AUA" },
    { name: "Querétaro Intercontinental Airport", airport_code: "QRO" },
    { name: "Rabat–Salé Airport", airport_code: "RBA" },
    { name: "Rafael Hernández Airport", airport_code: "BQN" },
    { name: "Regina International Airport", airport_code: "YQR" },
    { name: "Resistencia International Airport", airport_code: "RES" },
    { name: "Rickenbacker International Airport", airport_code: "LCK" },
    { name: "Robert L. Bradshaw International Airport", airport_code: "SKB" },
    { name: "Rock Sound International Airport", airport_code: "RSD" },
    { name: "Roland Garros Airport", airport_code: "RUN" },
    { name: "Ramón Villeda Morales International Airport", airport_code: "SAP" },
    { name: "Ronald Reagan Washington National Airport", airport_code: "DCA" },
    { name: "Savannah/Hilton Head International Airport", airport_code: "SAV" },
    { name: "Saltillo Airport", airport_code: "SLW" },
    { name: "Salt Lake City International Airport", airport_code: "SLC" },
    { name: "Samaná El Catey International Airport", airport_code: "AZS" },
    { name: "San Antonio International Airport", airport_code: "SAT" },
    { name: "San Bernardino International Airport", airport_code: "SBD" },
    { name: "San Carlos de Bariloche Airport", airport_code: "BRC" },
    { name: "San Diego International Airport", airport_code: "SAN" },
    { name: "San Francisco International Airport", airport_code: "SFO" },
    { name: "Sangster International Airport", airport_code: "MBJ" },
    { name: "San Jose International Airport", airport_code: "SJC" },
    { name: "San Luis Potosí International Airport", airport_code: "SLP" },
    { name: "Santa Maria Airport", airport_code: "RIA" },
    { name: "Sarasota–Bradenton International Airport", airport_code: "SRQ" },
    { name: "Scarlett Martínez International Airport", airport_code: "RIH" },
    { name: "Seattle–Tacoma International Airport", airport_code: "SEA" },
    { name: "Sfax–Thyna International Airport", airport_code: "SFA" },
    { name: "Sharm El Sheikh International Airport", airport_code: "SSH" },
    { name: "Sheboygan County Memorial Airport", airport_code: "SBM" },
    { name: "Sir Seretse Khama International Airport", airport_code: "GBE" },
    { name: "Southwest Florida International Airport", airport_code: "RSW" },
    { name: "Sphinx International Airport", airport_code: "SPX" },
    { name: "Spokane International Airport", airport_code: "GEG" },
    { name: "St. Catherine International Airport", airport_code: "SKV" },
    { name: "St. John's International Airport", airport_code: "YYT" },
    { name: "St. Louis Lambert International Airport", airport_code: "STL" },
    { name: "St. Pete–Clearwater International Airport", airport_code: "PIE" },
    { name: "Syracuse Hancock International Airport", airport_code: "SYR" },
    { name: "Taba International Airport", airport_code: "TCP" },
    { name: "Tabarka–Aïn Draham International Airport", airport_code: "TBJ" },
    { name: "Tallahassee International Airport", airport_code: "TLH" },
    { name: "Tampa International Airport", airport_code: "TPA" },
    { name: "Tampico International Airport", airport_code: "TAM" },
    { name: "Tangier Ibn Battouta Airport", airport_code: "TNG" },
    { name: "Terrance B. Lettsome International Airport", airport_code: "EIS" },
    { name: "Thunder Bay International Airport", airport_code: "YQT" },
    { name: "Tijuana International Airport", airport_code: "TIJ" },
    { name: "Tocumen International Airport", airport_code: "PTY" },
    { name: "Toluca International Airport", airport_code: "TLC" },
    { name: "Toncontín International Airport", airport_code: "TGU" },
    { name: "Ted Stevens Anchorage International Airport", airport_code: "ANC" },
    { name: "Wilkes-Barre/Scranton International Airport", airport_code: "AVP" },
    { name: "Ushuaia – Malvinas Argentinas International Airport", airport_code: "USH" },
    { name: "Toronto Pearson International Airport", airport_code: "YYZ" },
    { name: "Toussaint Louverture International Airport", airport_code: "PAP" },
    { name: "Tozeur–Nefta International Airport", airport_code: "TOE" },
    { name: "Tucson International Airport", airport_code: "TUS" },
    { name: "Tulsa International Airport", airport_code: "TUL" },
    { name: "Tunis–Carthage International Airport", airport_code: "TUN" },
    { name: "Uruapan International Airport", airport_code: "UPN" },
    { name: "V. C. Bird International Airport", airport_code: "ANU" },
    { name: "Vancouver International Airport", airport_code: "YVR" },
    { name: "Veracruz International Airport", airport_code: "VER" },
    { name: "Villahermosa International Airport", airport_code: "VSA" },
    { name: "Vilo Acuña Airport", airport_code: "CYO" },
    { name: "Viru Viru International Airport", airport_code: "VVI" },
    { name: "William P. Hobby Airport", airport_code: "HOU" },
    { name: "Wilmington International Airport", airport_code: "ILM" },
    { name: "Zacatecas International Airport", airport_code: "ZCL" },
    { name: "Abeid Amani Karume International Airport", airport_code: "ZNZ" },
    { name: "Aden Adde International Airport", airport_code: "MGQ" },
    { name: "Arua Airport", airport_code: "RUA" },
    { name: "Arusha Airport", airport_code: "ARK" },
    { name: "Beira Airport", airport_code: "BEW" },
    { name: "Benina International Airport", airport_code: "BEN" },
    { name: "Blaise Diagne International Airport", airport_code: "DSS" },
    { name: "Bosaso Airport", airport_code: "BSA" },
    { name: "Bram Fischer International Airport", airport_code: "BFN" },
    { name: "Cape Town International Airport", airport_code: "CPT" },
    { name: "Djibouti–Ambouli International Airport", airport_code: "JIB" },
    { name: "East London Airport", airport_code: "ELS" },
    { name: "Eldoret International Airport", airport_code: "EDL" },
    { name: "Entebbe International Airport", airport_code: "EBB" },
    { name: "Garowe Airport Somalia", airport_code: "ULU" },
    { name: "Hargeisa Airport", airport_code: "HGA" },
    { name: "Inhambane Airport", airport_code: "INH" },
    { name: "Harry Mwanga Nkumbula International Airport", airport_code: "LVI" },
    { name: "Winnipeg James Armstrong Richardson", airport_code: "YWG" },
    { name: "Joshua Mqabuko Nkomo International Airport", airport_code: "BUQ" },
    { name: "Jomo Kenyatta International Airport", airport_code: "NBO" },
    { name: "Julius Nyerere International Airport", airport_code: "DAR" },
    { name: "Kenneth Kaunda International Airport", airport_code: "LUN" },
    { name: "Khartoum International Airport", airport_code: "KRT" },
    { name: "Kilimanjaro International Airport", airport_code: "JRO" },
    { name: "King Shaka International Airport", airport_code: "DUR" },
    { name: "Kismayo Airport", airport_code: "KMU" },
    { name: "Kisumu International Airport", airport_code: "KIS" },
    { name: "Kruger Mpumalanga International Airport", airport_code: "MQP" },
    { name: "Lanseria International Airport", airport_code: "HLA" },
    { name: "Lomé–Tokoin International Airport", airport_code: "LFW" },
    { name: "Maputo International Airport", airport_code: "MPM" },
    { name: "Mitiga International Airport (Tajoura)", airport_code: "MJI" },
    { name: "Moi International Airport", airport_code: "MBA" },
    { name: "Mwanza Airport", airport_code: "MWZ" },
    { name: "Nampula Airport", airport_code: "APL" },
    { name: "O. R. Tambo International Airport", airport_code: "JNB" },
    { name: "Pemba Airport", airport_code: "POL" },
    { name: "Polokwane International Airport", airport_code: "PTG" },
    { name: "Port Sudan New International Airport", airport_code: "PZU" },
    { name: "Sabha Airport", airport_code: "SEB" },
    { name: "Tripoli International Airport", airport_code: "TIP" },
    { name: "Victoria Falls Airport", airport_code: "VFA" },
    { name: "Vilankulo Airport", airport_code: "VNX" },
    { name: "Simon Mwansa Kapwepwe International Airport", airport_code: "NLA" },
    { name: "Robert Gabriel Mugabe International Airport", airport_code: "HRE" },
  ]

  Airline_List = [
    { name: "Aeroflot", airline_code: "su", icon: "aeroflot_SU.png" },
    { name: "Air Astana", airline_code: "kc", icon: "air_astana_KC.png" },
    { name: "Air Canada", airline_code: "ac", icon: "air_canada_AC.png" },
    { name: "Air China", airline_code: "ca", icon: "air_china_CA.png" },
    { name: "Air Europa", airline_code: "ux", icon: "air_europa_UX.png" },
    { name: "Air France", airline_code: "af", icon: "air_france_AF.png" },
    { name: "Air India", airline_code: "ai", icon: "air_india_AI.png" },
    { name: "Air Macau", airline_code: "nx", icon: "air_macau_NX.png" },
    { name: "Madagascar Airlines", airline_code: "md", icon: "madagascar_airlines_MD.png" },
    { name: "Air Mauritius", airline_code: "mk", icon: "air_mauritius_MK.png" },
    { name: "Air New Zealand", airline_code: "nz", icon: "air_new_zealand_NZ.png" },
    { name: "Air Seychelles", airline_code: "hm", icon: "air_seychelles_HM.png" },
    { name: "Air Tanzania", airline_code: "tc", icon: "air_tanzania_TC.png" },
    { name: "Asiana Airlines", airline_code: "oz", icon: "asiana_airlines_OZ.png" },
    { name: "Austrian Airlines", airline_code: "os", icon: "austrian_airlines_OS.png" },
    { name: "Bangkok Airways", airline_code: "pg", icon: "bangkok_airways_PG.png" },
    { name: "Biman Bangladesh Airlines", airline_code: "bg", icon: "biman_bangladesh_airlines_BG.png" },
    { name: "British Airways", airline_code: "ba", icon: "british_airways_BA.png" },
    { name: "Brussels Airlines", airline_code: "sn", icon: "brussels_airlines_SN.png" },
    { name: "Cathay Pacific", airline_code: "cx", icon: "cathay_pacific_CX.png" },
    { name: "China Airlines", airline_code: "ci", icon: "china_airlines_CI.png" },
    { name: "China Eastern", airline_code: "mu", icon: "china_eastern_MU.png" },
    { name: "China Southern", airline_code: "cz", icon: "china_southern_CZ.png" },
    { name: "Delta Air Lines", airline_code: "dl", icon: "delta_air_lines_DL.png" },
    { name: "EgyptAir", airline_code: "ms", icon: "egyptair_MS.png" },
    { name: "El Al", airline_code: "ly", icon: "el_al_LY.png" },
    { name: "Ethiopian Airlines", airline_code: "et", icon: "ethiopian_airlines_ET.png" },
    { name: "Etihad Airways", airline_code: "ey", icon: "etihad_airways_EY.png" },
    { name: "EVA Air", airline_code: "br", icon: "eva_air_BR.png" },
    { name: "Finnair", airline_code: "ay", icon: "finnair_AY.png" },
    { name: "Flydubai", airline_code: "fz", icon: "flydubai_FZ.png" },
    { name: "Gulf Air", airline_code: "gf", icon: "gulf_air_GF.png" },
    { name: "Hong Kong Airlines", airline_code: "hx", icon: "hong_kong_airlines_HX.png" },
    { name: "Iran Air", airline_code: "ir", icon: "iran_air_IR.png" },
    { name: "Japan Airlines", airline_code: "jl", icon: "japan_airlines_JL.png" },
    { name: "Jazeera Airways", airline_code: "j9", icon: "jazeera_airways_J9.png" },
    { name: "Malaysia Airlines", airline_code: "mh", icon: "malaysia_airlines_MH.png" },
    { name: "Malindo Airways", airline_code: "od", icon: "malindo_airways_OD.png" },
    { name: "Myanmar Airways", airline_code: "ub", icon: "myanmar_airways_UB.png" },
    { name: "Nepal Airlines", airline_code: "ra", icon: "nepal_airlines_RA.png" },
    { name: "Pakistan International Airlines", airline_code: "pk", icon: "pakistan_international_airlines_PK.png" },
    { name: "Philippine Airlines", airline_code: "pr", icon: "philippine_airlines_PR.png" },
    { name: "Qantas Airways", airline_code: "qf", icon: "qantas_airways_QF.png" },
    { name: "Kenya Airways", airline_code: "kq", icon: "kenya_airways_KQ.png" },
    { name: "KLM Royal Dutch Airlines", airline_code: "kl", icon: "klm_royal_dutch_airlines_KL.png" },
    { name: "Korean Air", airline_code: "ke", icon: "korean_air_KE.png" },
    { name: "Kuwait Airways", airline_code: "ku", icon: "kuwait_airways_KU.png" },
    { name: "LATAM Airlines", airline_code: "la", icon: "latam_airlines_LA.png" },
    { name: "LOT Polish Airlines", airline_code: "lo", icon: "lot_polish_airlines_LO.png" },
    { name: "Lufthansa Airlines", airline_code: "lh", icon: "lufthansa_airlines_LH.png" },
    { name: "Qatar Airways", airline_code: "qr", icon: "qatar_airways_QR.png" },
    { name: "Royal Air Maroc", airline_code: "at", icon: "royal_air_maroc_AT.png" },
    { name: "Royal Brunei Airlines", airline_code: "bi", icon: "royal_brunei_airlines_BI.png" },
    { name: "Royal Jordanian", airline_code: "rj", icon: "royal_jordanian_RJ.png" },
    { name: "Saudi Arabian Airlines", airline_code: "sv", icon: "saudi_arabian_airlines_SV.png" },
    { name: "Scandinavian Airlines", airline_code: "sk", icon: "scandinavian_airlines_SK.png" },
    { name: "Shandong Airlines", airline_code: "sc", icon: "shandong_airlines_SC.png" },
    { name: "South African Airways", airline_code: "sa", icon: "south_african_airways_SA.png" },
    { name: "SriLankan Airlines", airline_code: "ul", icon: "srilankan_airlines_UL.png" },
    { name: "Swiss International Air Lines", airline_code: "lx", icon: "swiss_international_air_lines_LX.png" },
    { name: "Thai Airways", airline_code: "tg", icon: "thai_airways_TG.png" },
    { name: "Thai Lion Air", airline_code: "sl", icon: "thai_lion_air_SL.png" },
    { name: "Turkish Airlines", airline_code: "tk", icon: "turkish_airlines_TK.png" },
    { name: "United Airlines", airline_code: "ua", icon: "united_airlines_UA.png" },
    { name: "Vietnam Airlines", airline_code: "vn", icon: "vietnam_airlines_VN.png" },
    { name: "Virgin Atlantic", airline_code: "vs", icon: "virgin_atlantic_VS.png" },
  ]
}
